import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { FeatureToggle } from './featureToggles'
import { Permission } from './permissions'

export const manageProvidersPageAccessControl: DomainAccessControlConfig = [
  {
    featureToggles: [FeatureToggle.deliveryOrchestration],
    permissions: [Permission.View, Permission.Modify],
    restrictedBannersAllowed: true,
  },
  {
    warehouseFeatureToggles: [FeatureToggle.deliveryOrchestration],
    permissions: [Permission.View, Permission.Modify],
    restrictedBannersAllowed: true,
  },
]
